export function contactStatusLabelV2(status) {
    const opts = { unknown: 'No Preference', opt_in: 'Opted In', opt_out: 'Opted Out' };
    return opts[status];
}

export function contactStatusBadgeColorV2(status) {
    const opts = { unknown: 'grey', opt_in: 'success', opt_out: 'alert' };
    return opts[status];
}
